import { CONTEXT_KEY } from 'api/api-constants';
import { createAction } from 'redux-actions';
import { getElementsBySectionRequest } from 'api/element-api';
import { getSectionSegmentsRequest } from 'api/statement-content-api';
import { scrollSectionIntoView } from 'utils/scrolling-utils';
import { isNullOrUndefined } from 'utils/object-utils';
import { checkLeftCacheToPurge } from 'store/actions/left-statement-section-content-actions';
import { fetchLeftNotesBySection } from './notes-cache-actions';
import { isElementHasAnyAnnotations } from 'utils/statement-content-page-utils';

export const leftSectionHTMLSegmentsStatementContentLoading = createAction(
  'LEFT_SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADING',
);
export const leftSectionHTMLSegmentsStatementContentLoaded = createAction(
  'LEFT_SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_LOADED',
);
export const leftSectionHTMLSegmentsStatementContentError = createAction(
  'LEFT_SECTION_HTML_SEGMENTS_STATEMENT_CONTENT_ERROR',
);
export const leftElementDatapartStoreAction = createAction(
  'UPDATE_LEFT_ELEMENT_DATAPART_STORE',
);
export const leftSectionElementsLoading = createAction(
  'LEFT_SECTION_ELEMENTS_LOADING',
);
export const leftSectionElementsLoaded = createAction(
  'LEFT_SECTION_ELEMENTS_LOADED',
);
export const leftSectionElementsError = createAction(
  'LEFT_SECTION_ELEMENTS_ERROR',
);
export const clearLeftStatementPageStoreAction = createAction(
  'CLEAR_LEFT_STATEMENT_PAGE_STORE',
);

export const fetchLeftSectionHTMLSegmentsStatementContent =
  ({ statementId, sectionIdList, segmentType, scrollToSection }) =>
  async (dispatch, getStore) => {
    const {
      data: { leftRevision },
      ui: {
        sourceStatementParams: { projectId },
      },
    } = getStore();
    dispatch(leftSectionHTMLSegmentsStatementContentLoading(sectionIdList));
    getSectionSegmentsRequest({
      statementId,
      revisionId: leftRevision.id,
      sectionIdList,
      segmentType,
      contextKey: CONTEXT_KEY.PROJECT_CONTEXT,
      contextValue: projectId,
    })
      .then((response) => {
        const {
          ui: {
            statementPage: { contentSearch },
          },
        } = getStore();
        dispatch(
          leftSectionHTMLSegmentsStatementContentLoaded({
            response,
            searchTerm: contentSearch,
          }),
        );
        const sectionId = sectionIdList[0];
        if (scrollToSection && !isNullOrUndefined(sectionId)) {
          scrollSectionIntoView(sectionId);
        }
        // after set in cache, evaluate cache for left statement of side by side view page
        dispatch(checkLeftCacheToPurge());
        dispatch(
          leftElementDatapartStoreAction({
            response,
          }),
        );
      })
      .catch((error) => {
        dispatch(leftSectionHTMLSegmentsStatementContentError(error));
      });
  };

export const fetchLeftElementsBySection =
  ({ sectionId, statementId }) =>
  (dispatch, getStore) => {
    const {
      leftRevision,
      annotationDisplayOptions,
      leftStatementContent: { leftElementCache },
    } = getStore().data;
    const { sourceStatementParams } = getStore().ui;
    dispatch(leftSectionElementsLoading({ sectionId }));
    getElementsBySectionRequest({
      statementId,
      sectionId,
      revisionId: leftRevision.id,
      contextKey: CONTEXT_KEY.PROJECT_CONTEXT,
      contextValue: sourceStatementParams.projectId,
    })
      .then((response) => {
        if (response.data && annotationDisplayOptions.showAll) {
          response.data = response.data.map((item) => {
            return {
              ...item,
              marker: false,
              callout:
                isElementHasAnyAnnotations(item) &&
                annotationDisplayOptions.showAll,
            };
          });
        } else if (leftElementCache.getCurrentSectionIds().length) {
          const elementIds = leftElementCache.getElementIdsBySectionId({
            sectionId,
          });
          if (elementIds.marker.length || elementIds.callout.length) {
            response.data = response.data.map((item) => {
              return {
                ...item,
                marker: elementIds.marker.includes(item.id),
                callout:
                  elementIds.callout.includes(item.id) &&
                  isElementHasAnyAnnotations(item),
              };
            });
          }
        }
        dispatch(
          leftSectionElementsLoaded({
            response,
            sectionId,
          }),
        );
      })
      .catch((error) => {
        dispatch(leftSectionElementsError({ sectionId, error }));
      });
  };

/**
 * Fetches all data necessary for rendering section content and element annotations
 * @param {number} param.sectionId sectionId to fetch info for
 */
export const fetchAllLeftSectionRenderingData =
  ({ sectionId, scrollToSection }) =>
  (dispatch, getStore) => {
    const { sourceStatementParams } = getStore().ui;

    dispatch(
      fetchLeftSectionHTMLSegmentsStatementContent({
        statementId: sourceStatementParams.statementId,
        sectionIdList: [sectionId],
        segmentType: 'P',
        scrollToSection,
      }),
    );
    dispatch(
      fetchLeftElementsBySection({
        sectionId,
        statementId: sourceStatementParams.statementId,
      }),
    );
    dispatch(
      fetchLeftNotesBySection({
        sectionId,
        statementId: sourceStatementParams.statementId,
        projectId: sourceStatementParams.projectId,
      }),
    );
  };
